import React from "react";
import logo from "../images/logo.png";
import location from "../images/location.svg";
import mail from "../images/mail.svg";
import user from "../images/user.svg";
import facebook from "../images/facebook.svg";
import x from "../images/x.svg";
import yt from "../images/yt.svg";
import insta from "../images/insta.svg";
import whatsapp from "../images/whatsapp.svg";
import tictok from "../images/tictok.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="relative bg-darkblue dark:bg-bluedarkmode pb-[120px] s15:pb-[0px]">
      <div className="w-full max-w-[1565px] px-5 mx-auto">
        <div className="pt-[50px] lg:pt-10 s18:pt-[50px] pb-[30px] md:pb-10 xl:pb-12 2xl:pb-[101px] flex max-sm:flex-col sm:flex-wrap lg:flex-nowrap justify-center gap-[50px] sm:gap-10 xl:gap-28 2xl:gap-[180px]">
          <div className="w-full sm:w-[45%] lg:max-w-[200px] xl:max-w-[240px]">
            <Link
              to="/"
              className="h-9 lg:h-[43px] mb-10 flex justify-center sm:justify-start"
            >
              <img
                src={logo}
                alt="logo"
                className="w-fit h-full object-contain lg:w-[150px] s16:w-[180px] s18:w-auto"
              />
            </Link>
            <div className="flex flex-col gap-5 md:gap-3 s18:gap-5">
              <div className="flex flex-col max-sm:items-center max-sm:w-fit max-sm:mx-auto sm:flex-row gap-[10px] sm:gap-3 text-white hover:text-yellow text-sm font-normal transition-all dura">
                <img
                  src={location}
                  alt="location"
                  className="w-full max-w-[16px] object-contain"
                />
                P.O.BOX 25675-00100 NAIROBI
              </div>
              <Link
                to="mailto:care@jambobet.co.de"
                className="flex flex-col max-sm:items-center max-sm:w-fit max-sm:mx-auto sm:flex-row gap-[10px] sm:gap-3 text-white hover:text-yellow text-sm font-normal transition-all dura"
              >
                <img
                  src={mail}
                  alt="mail"
                  className="w-full max-w-[16px] object-contain"
                />
                care@jambobet.co.de
              </Link>
              <Link
                to="tel:+254 719 034 034"
                className="flex flex-col max-sm:items-center max-sm:w-fit max-sm:mx-auto sm:flex-row gap-[10px] sm:gap-3 text-white hover:text-yellow text-sm font-normal transition-all dura"
              >
                <img
                  src={user}
                  alt="user"
                  className="w-full max-w-[16px] object-contain"
                />
                +254 719 034 034
              </Link>
              <div className="flex max-sm:items-center max-sm:justify-center gap-5 mt-3">
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={facebook}
                    alt="facebook"
                    className="object-contain"
                  />
                </Link>
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={x}
                    alt="x"
                    className="object-contain hover:opacity-60 transition-all duration-300"
                  />
                </Link>
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={yt}
                    alt="yt"
                    className="object-contain hover:opacity-60 transition-all duration-300"
                  />
                </Link>
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={insta}
                    alt="insta"
                    className="object-contain hover:opacity-60 transition-all duration-300"
                  />
                </Link>
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={whatsapp}
                    alt="whatsapp"
                    className="object-contain hover:opacity-60 transition-all duration-300"
                  />
                </Link>
                <Link
                  to="/"
                  className="relative after:absolute after:content-[''] after:top-1/2 after:-translate-y-1/2 after:-right-[10px] after:w-[1px] after:h-5 after:bg-white/20 last:after:hidden"
                >
                  <img
                    src={tictok}
                    alt="tictok"
                    className="object-contain hover:opacity-60 transition-all duration-300"
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className="w-full sm:w-[45%] lg:max-w-[148px]">
            <h6 className="text-white text-lg font-bold max-sm:text-center mb-5 md:mb-3 s18:mb-5">
              Quick Links
            </h6>
            <ul className="flex flex-col gap-[17px] md:gap-3 s18:gap-[17px] max-sm:text-center">
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Download app
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  JamboBet odds
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Live score
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Stats
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  JamboBet News
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Terms and Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Responsible Gambling
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Data and Privacy
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-full sm:w-[45%] lg:max-w-[148px]">
            <h6 className="text-white text-lg font-bold max-sm:text-center mb-5 md:mb-3 s18:mb-5">
              Betting
            </h6>
            <ul className="flex flex-col gap-[17px] md:gap-3 s18:gap-[17px] max-sm:text-center">
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Sports
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Casino
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Live Casino
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Aviator
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Galaxys
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Crash
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-white text-sm font-normal hover:underline hover:text-yellow transition-all duration-300"
                >
                  Maestro
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-full sm:w-[45%] lg:max-w-[273px]">
            <h6 className="text-white text-lg font-bold max-sm:text-center mb-5 md:mb-3 s18:mb-5">
              Legal & Compliance
            </h6>
            <div className="flex flex-col gap-[17px] md:gap-3 s18:gap-5 max-sm:text-center">
              <div className="flex items-center justify-start max-sm:justify-center gap-2">
                {/* 18+ Circular Banner */}
                <div className="bg-yellow text-darkblue font-bold text-base min-w-[32px] min-h-[32px] w-8 h-8 flex items-center justify-center rounded-full shrink-0">
                  <span>18+</span>
                </div>

                {/* Responsible Gambling Message */}
                <p className="text-white text-sm font-normal">
                  JAMBOBET is a website accessible only to persons aged 18 years
                  and above. Gambling may lead to adverse effects if not
                  practiced in moderation. Please Play Responsibly.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full sm:w-[45%] lg:max-w-[273px]">
            <h6 className="text-white text-lg font-bold max-sm:text-center mb-5 md:mb-3 s18:mb-5">
              Licence
            </h6>
            <div className="flex flex-col gap-[17px] md:gap-3 s18:gap-5 max-sm:text-center">
              <div className="flex items-center justify-start max-sm:justify-center gap-2">
                <p className="text-white text-sm font-normal">
                  Tekonstruct Ltd, the opertor of JamboBet, the website licenced
                  and regulated bu the Betting Control and Licensing Board of
                  Kenya, under the Betting, Lotteries and Gaming Act, Cap 131,
                  Laws of Kenya, with Licence Numbers: BK 0000609 and PG 0000369
                  for the provision of Casino and Sport book Games
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-[18px] md:py-3 s18:py-[18px] text-center bg-[#182D4A] dark:bg-darktitleColor">
        <p className="text-white text-sm font-normal">
          Copyright © 2025{" "}
          <Link to="/" className="hover:text-yellow">
            Tekonstruct
          </Link>
          . All rights reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
